@if (!isTablet && !isMobile) {
<div ngbDropdown class="my-account-links-container d-flex h-100" placement="bottom-right">
  <button class="btn btn-link p-0 my-auto border-0" id="myAccountDropdown" ngbDropdownToggle>
    <mat-icon class="material-icons-sharp light">menu</mat-icon>
    <div
      ngbDropdownMenu
      class="dropdown-menu dropdown-menu-right rounded-0 border-0 js-header-menu"
      aria-labelledby="myAccountDropdown"
    >
      @for (item of myAccountNavNodeOverride?.children || myAccountNavNode.children; track item) { @if (!!item.url) {
      <button
        ngbDropdownItem
        class="d-flex align-items-center rounded-0 dropdown-customStyling"
        (click)="onClick(item.url, item.styleClasses)"
        [class.hidden]="item.url === '/dealer-selection' && !asmEnabled"
      >
        {{ item.title }}
      </button>
      } }
    </div>
  </button>
</div>
} @if (isTablet) {
<div [class.show]="showMyAccountDropdown" class="my-account-links-container-tablet dropdown d-flex h-100">
  <button
    class="btn btn-link dropdown-toggle p-0 my-auto border-0"
    [attr.aria-expanded]="showMyAccountDropdown"
    (click)="onClickMyAccountDropdown($event)"
    (clickOutside)="closeMyAccountDropdown()"
  >
    <mat-icon data-toggle="dropdown" class="material-icons-sharp light">menu</mat-icon>
    <mat-nav-list class="dropdown-menu dropdown-menu-edge rounded-0 border-0" [class.d-none]="!showMyAccountDropdown">
      <!-- My Account Menu -->
      @for (myAccountNav of myAccountLinksOverride || myAccountLinks; track myAccountNav) {
      <div>
        @if (myAccountNav.children) {
        <mat-list-item class="hamburger-menu-icon" (click)="onClickSubMenu($event, 0)" disableRipple>
          <mat-icon class="material-icons-sharp light">menu</mat-icon>
          <mat-icon class="material-icons-sharp light md-16 ml-auto menu-button" [class.rotated]="showSubSubMenu[0]"
            >expand_more</mat-icon
          >
        </mat-list-item>
        } @if (myAccountNav.children && showSubSubMenu[0]) {
        <div class="submenu-container" [class.expanded]="showSubSubMenu[0]" [class.d-none]="!showSubSubMenu[0]">
          @for (myAccountNavChild of myAccountNav.children; track myAccountNavChild) {
          <div class="subsubmenu-container d-xl-none">
            @if (myAccountNavChild.url) {
            <mat-list-item
              (click)="onClick(myAccountNavChild.url, myAccountNavChild.styleClasses)"
              disableRipple
              [class.hidden]="myAccountNavChild.url === '/dealer-selection' && !asmEnabled"
            >
              <span class="submenu">{{ myAccountNavChild.title | titlecase }}</span>
            </mat-list-item>
            }
          </div>
          }
        </div>
        }
      </div>
      }
      <!-- Header Links -->
      @for (headerLinkComponent of headerLinksMobileNavEntries; track headerLinkComponent) {
      <div>
        <mat-list-item class="header-links-class" (click)="onClick(headerLinkComponent.url)" disableRipple>
          <span class="submenu">{{ headerLinkComponent.linkName | titlecase }}</span>
        </mat-list-item>
      </div>
      }
      <!-- Languages -->
      @for (languageNav of languageMobileNavNode; track languageNav) {
      <div [class.no-flags]="!(isLanguageFlagIconEnabled$ | async)">
        @if (languageNav.children) {
        <mat-list-item class="language-class" (click)="onClickSubMenu($event, 1)" disableRipple>
          @if (languageNav.title === 'Languages' && activeLanguageCountryIsocode) {
          <span
            class="flag:{{
              (isCountryFlagInsteadEnabled$ | async)
                ? (activeCountry$ | async | uppercase)
                : activeLanguageCountryIsocode
            }} mr-2"
          ></span>
          } @if (languageNav.title === 'Languages') {
          <span class="submenu">{{ activeLanguageName | titlecase }}</span>
          }
          <mat-icon class="material-icons-sharp light md-16 ml-auto menu-button" [class.rotated]="showSubSubMenu[1]"
            >expand_more</mat-icon
          >
        </mat-list-item>
        } @if (languageNav.children && showSubSubMenu[1]) {
        <div class="submenu-container" [class.expanded]="showSubSubMenu[1]" [class.d-none]="!showSubSubMenu[1]">
          @for (languageNavChild of languageNav.children; track languageNavChild) {
          <div class="subsubmenu-container d-xl-none">
            @if (languageNavChild.url) {
            <mat-list-item (click)="onClick(languageNavChild.url)" disableRipple>
              <span class="submenu">{{ languageNavChild.title | titlecase }}</span>
            </mat-list-item>
            } @if (languageNavChild.isocode) {
            <mat-list-item (click)="setShimanoActiveLanguage(languageNavChild.isocode)" disableRipple>
              <span
                class="flag:{{
                  (isCountryFlagInsteadEnabled$ | async)
                    ? (activeCountry$ | async | uppercase)
                    : languageNavChild.country.isocode
                }} mr-1"
              ></span>
              <span class="subsubmenu" [class.selected]="activeLanguageIsocode === languageNavChild.isocode">{{
                languageNavChild.name | titlecase
              }}</span>
              <!-- test -->
              @if (activeLanguageIsocode === languageNavChild.isocode) {
              <mat-icon svgIcon="check" class="check-icon ml-auto md-12 dark"></mat-icon>
              }
            </mat-list-item>
            }
          </div>
          }
        </div>
        }
      </div>
      }
    </mat-nav-list>
  </button>
</div>
} @if (isMobile) {
<div class="my-account-links-container-mobile d-flex h-100">
  <button class="btn btn-link p-0 my-auto border-0" (click)="onShowMyAccountMobileDialogRef()">
    <mat-icon class="material-icons-sharp light">menu</mat-icon>
  </button>
</div>
}
